// Match keyboard order to the compact visual order without replacing Shopify's controls.
(() => {
  const movePreferencesLast = () => {
    const buttons = document.querySelector('#shopify-pc__banner .shopify-pc__banner__btns');
    const preferences = buttons?.querySelector('#shopify-pc__banner__btn-manage-prefs');
    if (!preferences) return false;
    if (buttons.lastElementChild !== preferences) buttons.append(preferences);
    return true;
  };

  const start = () => {
    if (movePreferencesLast()) return;
    const observer = new MutationObserver(() => {
      if (movePreferencesLast()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
